const firebaseConfig = {
  apiKey: "AIzaSyBJjY58hx5QU-AkHXns_9W1ebmVCzU5O-Q",
  authDomain: "brolift.firebaseapp.com",
  projectId: "brolift",
  storageBucket: "brolift.appspot.com",
  messagingSenderId: "299670732876",
  appId: "1:299670732876:web:4fdb8b517d874a5ede74e9",
  measurementId: "G-GWYRZ6CX9P"
};
export default firebaseConfig;